import { render } from "./EditUserProfile.vue?vue&type=template&id=64ad37fa"
import script from "./EditUserProfile.vue?vue&type=script&lang=js"
export * from "./EditUserProfile.vue?vue&type=script&lang=js"

import exportComponent from "/home/dyam/Documentos/KAYBU/mi-stock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__